// extracted by mini-css-extract-plugin
module.exports = {"popup__subtitle":"styles_popup__subtitle__oQFPp"};